import {Text, View} from '@react-pdf/renderer';
import React from 'react';
import {DateToddmmyyyyFormatNoError} from '../../../../data/factory';
import {styles} from './styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AssurranceRCVP = (props: any) => {
  const getCurrentDate = () => DateToddmmyyyyFormatNoError(new Date());
  const {detailContrat} = props;
  return (
    <View>
      <Text style={styles.title}>
        ASSURANCE RESPONSABILITÉ CIVILE VIE PRIVEE
      </Text>
      <View style={styles.sousSection}>
        <View style={{margin: 10}} />
        <Text>
          Police N°: {detailContrat.numeroPolice} n° Quitance :{' '}
          {detailContrat.id} Agence : {detailContrat.agence}
        </Text>
        <Text>
          Date d'effet: {detailContrat.dateSouscription} Date d'écheance :{' '}
          {detailContrat.dateEcheance} Rattachement : {detailContrat.agence}
        </Text>
        <Text>
          N° Souscripteur: {detailContrat.dateSouscription} Nom et prénoms ou
          Raison Sociale : {detailContrat.nomPrenomContractant}
        </Text>
        <Text>Adresse: {detailContrat.adresse} </Text>
        <Text style={{...styles.title, fontSize: 10}}>
          Table des garanties (en Ariary)
        </Text>
        <View style={{margin: 2}} />
        <Text>
          La territorialité du présent contrat correspond aux articles 5 et 8
          des conditions générales.
        </Text>
        <Text>
          Le présent contrat est établi sur la foi des déclarations du
          souscripteur qui reconnaît avoir reçu, en sus de la
        </Text>
        <Text>
          présente, les conditions spéciales Réf. 011 127 et les Conditions.
        </Text>
        <Text>
          Le contrat est souscrit pour une durée de douze mois SANS TACITE
          RECONDUCTION
        </Text>

        <Text style={{...styles.textBolded, marginTop: 20}}>
          Fait à Antananarivo, le {getCurrentDate()}
        </Text>
        <View style={{margin: 5}} />
        <View style={{flexDirection: 'row'}}>
          <Text style={styles.textBolded}>LE SOUSCRIPTEUR</Text>
          <Text
            style={{
              ...styles.textBolded,
              alignSelf: 'flex-end',
              marginLeft: 300,
            }}>
            L’ASSUREUR{' '}
          </Text>
        </View>
      </View>
    </View>
  );
};
